import React, {createContext, useReducer} from 'react'
import {PickFilterReducer} from "../reducers/PickFilterReducer";
import * as PickColumns from "../PickTableColumns";
import {
    DEFAULT_RC_PACKAGE_COUNT,
    DEFAULT_RC_TIME_LIMIT,
    DEFAULT_SPR_PACKAGE_COUNT,
    DEFAULT_SPR_TIME_LIMIT
} from "../../util/Constants";
import {PICK_FILTER_STATE_KEY} from "../../util/LocalStorageKeys";
import {saveFilterState} from "../../util/Util";

export const PickFilterContext = createContext();

const PickFilterContextProvider = (props) => {
    let initialState = {
        xptNodes: null,
        departure: [],
        pickByTime: [],
        aisleGroupStatus: [],
        picklistStatusInGrid: [],
        wavePluxXEnabled: [],
        pickWorkstations: [],
        driverType: [],
        cluster: [],
        status: [],
        routeStatus: [],
        workstationStatus: [],
        picklistStatus: [],
        routeSPR: [],
        atRisk: [],
        multiStationPicklists: [],
        sprPackageCount: DEFAULT_SPR_PACKAGE_COUNT,
        sprTimeLimit: DEFAULT_SPR_TIME_LIMIT,
        rcPackageCount: DEFAULT_RC_PACKAGE_COUNT,
        rcTimeLimit: DEFAULT_RC_TIME_LIMIT,
        data: {
            xptNodes: [],
            departure: [],
            pickByTime: [],
            pickWorkstations: [],
            driverType: [],
            cluster: []
        },
        selectedPickColumns: [
            PickColumns.STAGE_BY_TIME,
            PickColumns.STATION_PAIRS,
            PickColumns.PICK_BY_TIME,
            PickColumns.ROUTE_ID,
            PickColumns.PRIORITY,
            PickColumns.STATUS,
            PickColumns.CARTS,
            PickColumns.SPR,
            PickColumns.PROGRESS,
            PickColumns.ASSOCIATE,
            PickColumns.DURATION,
            PickColumns.LAST_PICK,
            PickColumns.TYPE
        ],
    }

    const urlState = props.context ? JSON.parse(props.context.replace('%2f', '/')) : null;
    if (urlState) {
        initialState = {...initialState, ...urlState};
        saveFilterState(PICK_FILTER_STATE_KEY, initialState);
    }

    const [viewModelF, dispatchF] = useReducer(PickFilterReducer, initialState);
    return (
        <PickFilterContext.Provider value={{viewModelF, dispatchF}}>
            {props.children}
        </PickFilterContext.Provider>
    )
}

export default PickFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/pickStatus/context/PickFilterContext.js